import { ColumnDataType } from 'components/elements/table/type';

export const columns = (t) => [
  {
    header: t('cruise:cabin'),
    accessorKey: 'cruiseRoomName',
    minSize: 180,
    maxSize: 200,
    dataType: ColumnDataType.text,
  },
  {
    header: t('cruise:cabin_number'),
    accessorKey: 'cruiseRoomNumber',
    minSize: 180,
    maxSize: 200,
    dataType: ColumnDataType.text,
  },
  {
    header: t('cruise:deck'),
    accessorKey: 'deck',
    minSize: 180,
    maxSize: 200,
    dataType: ColumnDataType.text,
  },
  {
    header: t('ticketSales:basic_fare'),
    accessorKey: 'basicFare',
    minSize: 150,
    maxSize: 150,
    dataType: ColumnDataType.number,
    minNumber: 0,
  },
  {
    header: t('ticketSales:port_charge'),
    accessorKey: 'portCharge',
    minSize: 150,
    maxSize: 150,
    dataType: ColumnDataType.number,
    minNumber: 0,
  },
  {
    header: t('ticketSales:tax'),
    accessorKey: 'tax',
    minSize: 150,
    maxSize: 150,
    dataType: ColumnDataType.number,
    minNumber: 0,
  },
  {
    header: t('ticketSales:tipping'),
    accessorKey: 'tipping',
    minSize: 150,
    maxSize: 150,
    dataType: ColumnDataType.number,
    minNumber: 0,
  },
  {
    header: t('cruise:reservation_number'),
    accessorKey: 'description',
    minSize: 150,
    dataType: ColumnDataType.text,
  },
];
